export function locationLabels(code?: string) {
  return String(code || '').toUpperCase() === 'ET'
    ? { region: 'Region / City administration', city: 'City / Town', postal: 'Postal code', street: 'Address / Kebele / Landmark' }
    : { region: 'State', city: 'City', postal: 'Zip code', street: 'Street Address' };
}
